import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	ViewChild,
} from '@angular/core';
import { $intakeDropdownViewModel } from '../../view-models/selectors';
import { dispatch, select } from '@ngxs/store';
import {
	DropdownComponent,
	DropdownItem,
} from '@ui/dropdown/dropdown.component';
import { IntakeFormStatus } from '@models/client-intake';
import { IntakeFormStatusDropdownOptions } from '../../view-models/models';
import { UpdateStatus } from '@state/matter/client-intake/client-intake.actions';
import { TestHooks } from './intake-dropdown.hooks';
import { ButtonComponent } from 'src/app/ui/button/button.component';
import { TestHookDirective } from '@core/ui';
import { NavigationService } from '@services/nav/nav.service';
import { Logger } from '@core/logger';
import { NgClass, NgIf } from '@angular/common';
import { IconsModule } from 'src/app/ui/icons/icons.module';
import { ModalService } from 'src/app/ui/modal/modal.service';
import { CancelIntakeFormConfirmationModalComponent } from '../cancel-intake-form-confirmation-modal/cancel-intake-form-confirmation-modal.component';
import { UI_TYPES } from '@ui/modal/modal.types';

@Component({
	selector: 'app-intake-dropdown',
	templateUrl: './intake-dropdown.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		DropdownComponent,
		ButtonComponent,
		TestHookDirective,
		NgClass,
		IconsModule,
		NgIf,
	],
})
export class IntakeDropdownComponent {
	@ViewChild('uiDropdown') dropdown!: DropdownComponent;

	private navService = inject(NavigationService);
	private modalService = inject(ModalService);

	testHooks = TestHooks;

	viewModel_ = select($intakeDropdownViewModel);

	currIntakeFormStatus_ = computed(() => {
		const status = this.viewModel_()?.intakeForm?.status;
		return status ?? null;
	});

	updateStatus = dispatch(UpdateStatus);

	public readonly intakeFormStatusDropdownOptions =
		IntakeFormStatusDropdownOptions;

	async setSelectedIntakeFormStatus(item: DropdownItem) {
		const selectedIntakeFormStatus = item.id as IntakeFormStatus;

		if (!this.viewModel_()?.intakeForm) {
			Logger.warn('Cannot set intake form status, no intake form found');
			return;
		}

		if (selectedIntakeFormStatus === IntakeFormStatus.CANCELLED) {
			this.getCancellationConfirmation();
			return;
		}

		this.updateStatus({
			intakeFormId: this.viewModel_().intakeForm?.id,
			status: selectedIntakeFormStatus,
		});
	}

	selectItem(event: MouseEvent, item: DropdownItem): void {
		event.stopPropagation();
		this.setSelectedIntakeFormStatus(item);
		this.dropdown.closeDropdown();
	}

	getCancellationConfirmation() {
		return this.modalService.openModal(
			CancelIntakeFormConfirmationModalComponent,
			{
				title: 'Cancel Intake Request',
				size: 'sm',
				type: UI_TYPES.DANGER,
				primaryAction: {
					text: 'Continue',
					action: () => {
						this.modalService.closeModal();
						this.cancelCurrentIntakeForm();
					},
				},
				secondaryAction: {
					text: 'Back',
					action: () => {
						this.modalService.closeModal();
					},
				},
			},
		);
	}

	cancelCurrentIntakeForm() {
		this.updateStatus({
			intakeFormId: this.viewModel_().intakeForm?.id,
			status: IntakeFormStatus.CANCELLED,
		});

		const matterId = this.viewModel_()?.matterId;
		if (matterId) {
			this.navService.goToMatter_Parties(matterId);
		}
	}
}
